import { useEffect } from 'react';
export default function useEffectIf(cond, callback) {
    useEffect(() => {
        if (cond) {
            callback();
        }
    }, [cond]);
}
